// @flow

import React, { Component } from "react";
import classNames from "classnames";

import { ComboBox } from "@components";
import type { OptionType } from "@components";
import type { WidgetProps } from "@rjsf/utils";
type Props = $Exact<{
  ...WidgetProps,
  options: Object,
}>;

export function SelectWidget(props: Props) {
  function handleChange(val: OptionType) {
    props.onChange && props.onChange(val);
  }

  function handleReset(val: OptionType) {
    handleChange(-1);
  }

  let options = [];
  if (props?.options?.enumOptions) {
    options = props.options.enumOptions.map(opt => {
      return { value: opt.value, label: opt.label };
    });
  } else if (props.oneOf) {
    options = props.oneOf;
  }

  const uiOptions = (props.uiSchema && props.uiSchema["ui:options"]) || {};

  return (
    <ComboBox
      id={props.id}
      name={props.name}
      onChange={handleChange}
      options={options}
      value={props.value}
      disabled={props.disabled}
      readOnly={props.readonly}
      withoutPortal={!!props.withoutPortal}
      className={classNames("", props.className)}
      asyncOptions={uiOptions.asyncOptions}
      onSelect={uiOptions.onSelect}
    />
  );
}

export default SelectWidget;
